export const TakingIdAction = (uIdValue) => {
    return {
        type: 'uIdValue',
        payLoad: uIdValue
    }
}
export const storeUserDetailsAction = (userData) => {
    return {
        type: "storeUserData",
        payLoad: userData,
    };
};
export const storeUserDetailsActionPhyInv = (userData) => {
    return {
        type: "storeUserData",
        payLoad: userData,
    };
};
export const saveAzureAccessTokenAction = (token) => {
    return {
        type: "saveAzureAccessToken",
        payLoad: token,
    };
};

export const saveAzureAccessTokenActionPhyInv = (token) => {
    return {
        type: "saveAzureAccessToken",
        payLoad: token,
    };
};

export const AppIDAction = (AppID) => {
    return {
        type: "AppID",
        payLoad: AppID,
    };
};

export const saveBearerTokenAction = (token) => {
    return {
        type: "saveBearerToken",
        payLoad: token,
    };
};
export const saveBearerTokenActionPhyInv = (token) => {
    return {
        type: "saveBearerToken",
        payLoad: token,
    };
};
export const saveUIDAction = (token) => {
    return {
        type: "saveUID",
        payLoad: token,
    };
};

export const saveUIDActionPhyInv = (token) => {
    return {
        type: "saveUID",
        payLoad: token,
    };
};

export const storeLandingMenuItemsAction = (menuItems) => {
    return {
      type: "saveLandingMenuItems",
      payLoad: menuItems,
    };
  };

  export const storeEperformanceLandingMenuItemsAction = (menuItems) => {
    return {
      type: "saveEperformanceLandingMenuItems",
      payLoad: menuItems,
    };
  };

  export const storePhyInvLandingMenuItemsAction = (menuItems) => {
    return {
      type: "savePhyInvLandingMenuItems",
      payLoad: menuItems,
    };
  };

  




